<template>
    <PDA_Issues-components>
        <div>
            <b-row>
                <!-- Table -->
                <b-col md="4">
                    <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage" :busy="isBusy" id="my-table">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>  
                        <template slot="issue_name" slot-scope="row">
                            <div>
                                <!-- <b-form-radio @input="editIssueinfo(row.item)" :aria-describedby="ariaDescribedby" name="some-radios" :value="row.item">&nbsp;{{row.item.pda_name}}</b-form-radio> -->
                                <!-- #0da9ae -->
                                <span style="font-size: 16px; color: #1c9ac7; cursor: pointer;" @click="!isReadOnly && editIssueinfo(row.item)"> <b> &gt; </b> &nbsp;{{row.item.issue_name}}</span>
                            </div>
                        </template>
                    </b-table>
        
                    <!-- paginaton -->
                    <b-col md="12">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table"></b-pagination>
                    </b-col>
                </b-col>
                <b-col md="1">
                    <div id="listloader" v-if="Loader">
                        <div class="listloader"></div>
                    </div>
                </b-col>
                <b-col md="7" class="mt-5" v-if="addIssue">
                    <b-row>
                        <b-col md="7">
                            <b-row>
                                <b-col md="4">
                                    <strong>Issue Name : </strong>
                                </b-col>
                                <b-col md="8">
                                    <b-form-input v-model.trim="customer.issue_name" placeholder="Enter Issue  Name" name="Issue Name"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5">
                            <b-row>
                                <b-col md="7">
                                    <strong>Active / InActive : </strong>
                                </b-col>
                                <b-col md="5">
                                    <b-form-checkbox switch class="mr-n2" v-model="customer.status">
                                        <span class="sr-only">Switch for previous text input</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="11">
                            <div class="text-right">
                                <br>
                                <b-button variant="primary" type="submit" @click="addIssueList()" :disabled="isReadOnly">Save</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7" class="mt-5" v-if="editIssue">
                    <b-row>
                        <b-col md="7">
                            <b-row>
                                <b-col md="4">
                                    <strong>Issue Name : </strong>
                                </b-col>
                                <b-col md="8">
                                    <b-form-input v-model.trim="user.issue_name" placeholder="Enter Issue Name" name="Issue Name"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5">
                            <b-row>
                                <b-col md="7">
                                    <strong>Active / InActive : </strong>
                                </b-col>
                                <b-col md="5">
                                    <b-form-checkbox switch class="mr-n2" @change="checkstatus" :checked="user.status === '1' || user.status === 'Yes'" :disabled="isReadOnly">
                                        <span class="sr-only">Switch for previous text input</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="11">
                            <div class="text-right">
                                <br>
                                <b-button variant="primary" type="submit" @click="editIssueList()">Save</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </PDA_Issues-components>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    name: 'PDA_Issues',

    data() {
        return {
            Loader:false,
        
            // Table
            isBusy:false,
            totalRows:0,
            items:[],
            fields:[
                {key:'issue_name', label:'Issue Name', thClass: 'text-center'},
            ],
            currentPage:1,
            perPage:20,
            customer:{},
            addIssue:true,

            editIssue:false,
            user:{},
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
          this.ischeckbodyvalidation();
        this.issueList()
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='PDA Configuration' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='PDA Configuration' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        
        issueList(){
            this.items=[];
            this.totalRows=0;

            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={
                status:'add'
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addPDAIssueList`,Obj)
            .then(result=>{
                this.isBusy=false;
                if (result.body.returnmsg==='Successful') {
                    this.items = result.body.returnvalue;
                    this.totalRows =  this.items.length;
                } else {
                    this.items=[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        addIssueList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.Loader = true;
            

            if (this.customer.issue_name==undefined || this.customer.issue_name==null || this.customer.issue_name=="" || this.customer.issue_name=='undefined' || this.customer.issue_name=='null') {
                this.$fire({
                    text: 'Please Enter Issue Name',
                    type: "warning",
                    timer: 30000,
                });
                this.Loader = false;
                return false;
            }

            const Obj = {
                issue_name: `${this.customer.issue_name}`,
                is_active: `${this.customer.status?'1':'0'}`,
                createdby: `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addPDAIssue`,Obj)
            .then(result=>{
                console.log("result",result)
                this.Loader = false;
                if (result.body.returnmsg==='Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    this.issueList()
                    this.customer={};
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        editIssueinfo(value){
            this.user = {};
            this.addIssue = false;
            this.editIssue = true;
            this.user.issue_id = value.issue_id;
            this.user.issue_name = value.issue_name;
            this.user.status = value.is_active;
        },

        checkstatus(value){
            if (value===false) {
                this.user.status='0';
            } else {
                this.user.status='1';
            }
        },

        editIssueList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.Loader = true;
            

            if (this.user.issue_name==undefined || this.user.issue_name==null || this.user.issue_name=="" || this.user.issue_name=='undefined' || this.user.issue_name=='null') {
                this.$fire({
                    text: 'Please Enter Issue Name',
                    type: "warning",
                    timer: 30000,
                });
                this.Loader = false;
                return false;
            }
            
            const Obj = {
                issue_id: this.user.issue_id,
                issue_name: `${this.user.issue_name}`,
                is_active: `${this.user.status}`,
                lastmodifiedby: `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/editPDAIssue`,Obj)
            .then(result=>{
                console.log("result",result)
                this.Loader = false;
                if (result.body.returnmsg==='Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    this.issueList()
                    this.user={};
                    this.addIssue = true;
                    this.editIssue = false;
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    },

    computed: {
        rows() {
            return this.items.length
        }
    }
}
</script>